export default (value) => {
    if (!value) {
        return '-'
    }
    if(value.length > 30){
        return value.substring(0, 30) + '...'
    }
    return value
}

